<template>
    <div class="onlineChart">
        <div class="chart">
            <v-chart autoresize :options="options1" v-if="options1" />
        </div>
        <div class="chart">
            <v-chart autoresize :options="options2" v-if="options2" />
        </div>
    </div>
</template>

<script>
const moment = require('moment');
export default {
    props:{
        flatData:"",
        tableTimeList:"",
        timeType:"",
        deviceType:"",
    },
    data() {
        return {
            options1: "",
            options2: "",
            legend1:[],
            legend2:[],
            map:[
                {
                    name: "颗粒物",
                    ids: [16],
                    deviceType: [1]
                },
                {
                    name: "颗粒物",
                    ids: [55],
                    deviceType: [2]
                },
                {
                    name: "颗粒物",
                    ids: [93],
                    deviceType: [3]
                },
                {
                    name: "二氧化硫",
                    ids: [12],
                    deviceType: [1]
                },
                {
                    name: "二氧化硫",
                    ids: [51],
                    deviceType: [2]
                },
                {
                    name: "二氧化硫",
                    ids: [89],
                    deviceType: [3]
                },
                {
                    name: "氮氧化物",
                    ids: [14],
                    deviceType: [1]
                },
                {
                    name: "氮氧化物",
                    ids: [53],
                    deviceType: [2]
                },
                {
                    name: "氮氧化物",
                    ids: [91],
                    deviceType: [3]
                },
                {
                    name: "氧含量",
                    ids: [100],
                    deviceType: [3]
                },
                {
                    name: "氧含量",
                    ids: [61],
                    deviceType: [2]
                },
                {
                    name: "氧含量",
                    ids: [100],
                    deviceType: [3]
                },
                {
                    name: "烟气流速",
                    ids: [11],
                    deviceType: [1]
                },
                {
                    name: "烟气流速",
                    ids: [50],
                    deviceType: [2]
                },
                {
                    name: "烟气流速",
                    ids: [88],
                    deviceType: [3]
                },
                {
                    name: "烟气温度",
                    ids: [],
                    deviceType: [1]
                },
                {
                    name: "烟气温度",
                    ids: [],
                    deviceType: [2]
                },
                {
                    name: "烟气温度",
                    ids: [],
                    deviceType: [3]
                },
                {
                    name: "烟气湿度",
                    ids: [],
                    deviceType: [1]
                },
                {
                    name: "烟气湿度",
                    ids: [],
                    deviceType: [2]
                },
                {
                    name: "烟气湿度",
                    ids: [],
                    deviceType: [3]
                },
                {
                    name: "烟气压力",
                    ids: [],
                    deviceType: [1]
                },
                {
                    name: "烟气压力",
                    ids: [],
                    deviceType: [2]
                },
                {
                    name: "烟气压力",
                    ids: [],
                    deviceType: [3]
                },
                {
                    name: "烟气流量",
                    ids: [18],
                    deviceType: [1]
                },
                {
                    name: "烟气流量",
                    ids: [57],
                    deviceType: [2]
                },
                {
                    name: "烟气流量",
                    ids: [96],
                    deviceType: [3]
                },
                {
                    name: "污水处理后出水流量",
                    ids: [251],
                    deviceType: [5]
                },
                {
                    name: "污水出水COD",
                    ids: [235],
                    deviceType: [5]
                },
                {
                    name: "污水出水氨氮",
                    ids: [236],
                    deviceType: [5]
                },
                {
                    name: "污水出水PH",
                    ids: [237],
                    deviceType: [5]
                },
                {
                    name: "B区雨排口南COD",
                    ids: [325],
                    deviceType: [6]
                },
                {
                    name: "B区雨排口南氨氮",
                    ids: [326],
                    deviceType: [6]
                },
                {
                    name: "B区雨排口北COD",
                    ids: [327],
                    deviceType: [7]
                },
                {
                    name: "B区雨排口北氨氮",
                    ids: [328],
                    deviceType: [7]
                },
                {
                    name: "锅炉窖井",
                    ids: [358],
                    deviceType: [8]
                },
                {
                    name: "气化窖井COD",
                    ids: [360],
                    deviceType: [9]
                },
                {
                    name: "气化窖井氨氮",
                    ids: [361],
                    deviceType: [9]
                },
                {
                    name: "甲醇窖井COD",
                    ids: [359],
                    deviceType: [10]
                },
                {
                    name: "醋酸窖井COD",
                    ids: [362],
                    deviceType: [11]
                }
            ],
            color:{
                "颗粒物":"#296FFF",
                "二氧化硫":"#1CC187",
                "氮氧化物":"#B059FF",
                "氧含量":"#61C005",
                "烟气流速":"#3D9FAA",
                "烟气温度":"#32945F",
                "烟气动压":"#A2AE31",
                "烟气湿度":"#8233A9",
                "烟气压力":"#D7A85D",
                "烟气流量":"#27B4FF",
                "污水处理后出水流量":"#27B4FF",
                "污水出水COD":"#1CC187",
                "污水出水氨氮":"#B059FF",
                "污水出水PH":"#296FFF",
                "B区雨排口南COD":"#1CC187",
                "B区雨排口南氨氮":"#B059FF",
                "B区雨排口南COD":"#1CC187",
                "B区雨排口南氨氮":"#B059FF"
            }
        }
    },
    methods: {
        getMapIndex(id){
            let index_ = -1
            this.map.forEach((item,index)=>{
                if(item.ids.includes(id) && item.deviceType.includes(this.deviceType)){
                    index_ = index
                }
            })
            if(this.deviceType == 5){
                index_ = index_ - 12
            }
            return index_
        },
        getTimeIndex(time){
            let timeIndex = -1
            this.tableTimeList.forEach((item,index)=>{
                if(item == time){
                    timeIndex = index
                }
            })
            return timeIndex
        },
        getData() {
            let data1 = []
            let xAxis1 = this.tableTimeList
            this.legend1 = []
            this.map.forEach(item=>{
                if(item.deviceType.includes(this.deviceType)){
                    this.legend1.push(item.name)
                    let obj = {
                        name: item.name,
                        type: 'line',
                        smooth:true,
                        itemStyle:{
                            color:this.color[item.name]
                        },
                        ids:item.ids,
                        data:[]
                    }
                    xAxis1.forEach(xAxis1Item=>{
                        obj.data.push({value:0.001,showValue:0,time:xAxis1Item})
                    })
                    data1.push(obj)
                }
            })

            let data2 = []
            let xAxis2 = this.tableTimeList
            if(this.deviceType == 5){
                this.legend2 = ["氨氮"]
            }else{
                this.legend2 = ["颗粒物","二氧化硫","氮氧化物"]
            }
            this.legend2.forEach(item=>{
                let obj = {
                    name: item,
                    type: 'line',
                    barWidth:5,
                    itemStyle:{
                        color:this.color[item]
                    },
                    data:[]
                }
                xAxis2.forEach(xAxis2Item=>{
                    obj.data.push({value:0,showValue:0,time:xAxis2Item})
                })
                data2.push(obj)
            })
            
            this.flatData.forEach(item=>{
                item.showSiteDeviceAi = item.siteDeviceAi
                item.lineSiteDeviceAi = item.siteDeviceAi
                if(item.lineSiteDeviceAi <= 0.001){
                    item.lineSiteDeviceAi = 0.001
                }
                let timeIndex = this.tableTimeList.indexOf(item.intTime.toString());
                //data1
                data1.forEach(data1Item=>{
                    if(data1Item.ids.includes(item.id)){
                        data1Item.data[timeIndex].value = parseFloat(item.lineSiteDeviceAi)
                        data1Item.data[timeIndex].showValue = parseFloat(item.showSiteDeviceAi)
                    }
                })
                //data2
                let yqllList = data1.filter(yqllItem=>{
                    return yqllItem.name == "烟气流量"
                })
                if(yqllList.length){
                    data1.forEach(data1Item=>{
                        let value = 0
                        let showValue = 0
                        if(yqllList[0].data[timeIndex].value <= 0.001 || data1Item.data[timeIndex].value <= 0.001){
                            value = 0
                        }else{
                            value = (yqllList[0].data[timeIndex].value * data1Item.data[timeIndex].value  / 60000000)
                        }
                        if(yqllList[0].data[timeIndex].showValue <= 0.001 || data1Item.data[timeIndex].showValue <= 0.001){
                            showValue = 0
                        }else{
                            showValue = (yqllList[0].data[timeIndex].showValue * data1Item.data[timeIndex].showValue  / 60000000)
                        }
                        if(showValue == 0){
                            value = 0
                        }
                        if(data1Item.name == "颗粒物"){
                            data2[0].data[timeIndex].value = value.toFixed(6)
                            data2[0].data[timeIndex].showValue = showValue.toFixed(6)
                        }else if(data1Item.name == "二氧化硫"){
                            data2[1].data[timeIndex].value = value.toFixed(6)
                            data2[1].data[timeIndex].showValue = showValue.toFixed(6)
                        }else if(data1Item.name == "氮氧化物"){
                            data2[2].data[timeIndex].value = value.toFixed(6)
                            data2[2].data[timeIndex].showValue = showValue.toFixed(6)
                        }else if(data1Item.name == "氨氮"){
                            data2[0].data[timeIndex].value = (value * 1000).toFixed(6)
                            data2[0].data[timeIndex].showValue = (showValue * 1000).toFixed(6)
                        }
                    })
                    this.initChart2(data2,xAxis2)
                }
            })
            this.initChart1(data1,xAxis1)
        },
        initChart1(data1,xAxis1) {
            this.options1 = {
                title: {
                    text: '浓度'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter:(e=>{
                        let html = moment(e[0].name, 'YYYYMMDDHHmm').
                        format(
                            this.timeType == "天" ? 'YYYY-MM-DD' : 
                            this.timeType == "小时" ? 'YYYY-MM-DD HH时' : 
                            'YYYY-MM-DD HH:mm'
                        )
                        e.forEach(item=>{
                            html += "</br>"+item.marker+item.seriesName+":"+item.data.showValue
                        })
                        return html
                    })
                },
                legend: {
                    icon:"circle",
                    data: this.legend1
                },
                xAxis: {
                    boundaryGap: false,
                    axisTick:{show:false},
                    axisLine:{show:false},
                    data: xAxis1,
                    axisLabel:{
                        formatter:(data)=>{
                            return moment(data, 'YYYYMMDDHHmm').
                            format(
                                this.timeType == "天" ? 'YYYY-MM-DD' : 
                                this.timeType == "小时" ? 'YYYY-MM-DD HH时' : 
                                'YYYY-MM-DD HH:mm'
                            )
                        }
                    }
                    
                },
                yAxis: {
                    axisTick:{show:false},
                    axisLine:{show:false},
                    splitLine:{
                        lineStyle:{
                            color:"#E4E7EE"
                        }
                    },
                    // 
                    min:0.001,
                    // max:1000000,
                    // data:[0.001,0.01,0.1,1,10,100,1000,10000,100000,1000000],
                    type: 'log',
                    logBase:10
                },
                series: data1
            }
        },
        initChart2(data2,xAxis2) {
            this.options2 = {
                title: {
                    text: '排放量'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter:(e=>{
                        let html = moment(e[0].name, 'YYYYMMDDHHmm').
                        format(
                            this.timeType == "天" ? 'YYYY-MM-DD' : 
                            this.timeType == "小时" ? 'YYYY-MM-DD HH时' : 
                            'YYYY-MM-DD HH:mm'
                        )
                        e.forEach(item=>{
                            html += "</br>"+item.marker+item.seriesName+":"+item.data.showValue
                        })
                        return html
                    })
                },
                legend: {
                    icon:"circle",
                    data: this.legend2
                },
                xAxis: {
                    type: 'category',
                    axisTick:{show:false},
                    axisLine:{show:false},
                    data: xAxis2,
                    axisLabel:{
                        formatter:(data)=>{
                            return moment(data, 'YYYYMMDDHHmm').
                            format(
                                this.timeType == "天" ? 'YYYY-MM-DD' : 
                                this.timeType == "小时" ? 'YYYY-MM-DD HH时' : 
                                'YYYY-MM-DD HH:mm'
                            )
                        }
                    }
                },
                grid:{
                },
                yAxis: {
                    axisTick:{show:false},
                    axisLine:{show:false},
                    splitLine:{
                        lineStyle:{
                            color:"#E4E7EE"
                        }
                    },
                    type: 'value'
                },
                series: data2
            }
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style lang="scss" scoped>
.onlineChart {
    width: 100%;
    height: calc(100% - 20px);
    background-color: white;

    .chart {
        width: 100%;
        height: 50%;
    }
}
</style>